var FileVisibilityDisplayOptions;
(function (FileVisibilityDisplayOptions) {
  FileVisibilityDisplayOptions["RADIO"] = "RADIO";
  FileVisibilityDisplayOptions["DROPDOWN"] = "DROPDOWN";
})(FileVisibilityDisplayOptions || (FileVisibilityDisplayOptions = {}));
export default FileVisibilityDisplayOptions;